<template>
  <div>
    <!-- temporary modal whilst marking -->
    <b-modal ref="markingModal" id="modalsm" size="sm" title="Small Modal" v-show="true">
      <div slot="modal-header"></div>
      Marking as resolved, please wait&hellip;
      <div slot="modal-footer"></div>
    </b-modal>

    <b-card-group columns>
      <b-card v-for="(report, index) in statefulReports" :key="report.link_location + report.raised_at_utc.value"
        :header="reportDescription(report)"
        :bg-variant="bgVariant(report)"
        :text-variant="textVariant(report)"
        :img-src="imageSource(report)"
        :title="siteName(report)">
        <div>
          <i v-if="report.is_resolved" class="fas fa-check-square text-success" style="font-size:25pt;margin:20px 0"> Resolved</i>
        </div>

        <p class="card-text" v-if="report.message" v-text="smartMessage(report.message)"/>
        <p class="card-text" v-if="report.report_type === 'P'">Service made contact with Landscape.</p>
        <b-button-group v-if="report.report_type !== 'P'">
          <b-button v-if="!hideSiteName" variant="primary" :to="{ name: 'server-details', params: { server: report.link_location } }">View Store</b-button>
          <b-button v-if="!report.is_resolved" variant="success" @click="markOneAsResolved(index, report)">Resolve</b-button>
        </b-button-group>
        <div slot="footer">
            <small v-b-tooltip.hover :title="report.raised_at_utc.value | moment('DD/MM/YYYY h:mm:ss a')">
              <i class="fas fa-clock"></i>&nbsp;
              {{ report.raised_at_utc.value + ' Z' | moment('HH:mm') }}
              Received {{ report.raised_at_utc.value + ' Z' | moment('from', 'now') }}</small>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import * as moment from 'moment';

export default {
  props: ['reports', 'hideSiteName'],

  data() {
    return {
      statefulReports: this.reports,
    };
  },

  methods: {
    siteName(report) {
      return this.hideSiteName ? null : report.location;
    },

    utcnow() {
      console.log('utcnow is ', moment().utc().toDate());
      return moment().utc().toDate();
    },
    reportDescription(report) {
      switch (report.report_type) {
        case 'P':
          return 'Ping';
        case 'S':
          return `Service: ${report.topic}`;
        case 'C':
          return `Camera: ${report.topic}`;
        case 'E':
          return 'Error';
        default:
          return 'General Error';
      }
    },
    bgVariant(report) {
      if (report.is_resolved) {
        return 'default';
      }
      switch (report.report_type) {
        case 'P':
          return 'default';
        case 'S':
          return 'warning';
        case 'C':
          return 'dark';
        default:
          return 'danger';
      }
    },
    textVariant(report) {
      if (report.is_resolved) {
        return 'black';
      }
      switch (report.report_type) {
        case 'S':
        case 'P':
          return 'black';
        default:
          return 'white';
      }
    },
    smartMessage(message) {
      const match = message.match(/^Camera folder was inactive for ([0-9\.,]+)\s?secs$/);
      if (match != null) {
        const seconds = Math.ceil(parseFloat(match[1]));
        const human = moment.duration(seconds, 'seconds').humanize();
        return `Inactive camera folder, no new content for ${human}`;
      }
      return message;
    },
    imageSource(report) {
      switch(report.report_type) {
        case 'C':
          return require('../assets/cameras.jpg');
        case 'E':
        case 'M':
          return require('../assets/crash.jpg');
        case 'P':
          return require('../assets/report.jpg');
        default:
          return null;
      }
    },
    markOneAsResolved(recordIndex, record) {
      console.log('marking item as done');
      this.error = null;
      this.$refs.markingModal.show();
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('landscape', access_token, {
        actionName: 'markOneReportAsResolved',
        parameters: {
          raised_at_utc: record.raised_at_utc.value,
          report_type: record.report_type,
          location: record.link_location,
        },
      })
      .then((r) => {
        console.log('done, success', r);
        // update the data for this row
        const copyOfRecords = [...this.statefulReports];
        copyOfRecords[recordIndex].is_resolved = true;
        this.statefulReports = copyOfRecords;
      })
      .catch((e) => {
        console.error(e.message);
        this.error = e.message;
      })
      .finally(() => {
        this.$refs.markingModal.hide();
      });
    },
  },
};
</script>

<style scoped>
.markedAsResolved {
  color: #aaa;
}
</style>
